import React, { useEffect } from "react";
import { Auth, GetEntityDetails, GetRoles } from "./../utils/auth";
import Cookie from "universal-cookie";
import axios from "axios";
import jwt from "jwt-decode";
import { config } from '../config';
export const TenantID = GetEntityDetails();

const accessToken = Auth();
const roles = GetRoles();
export const isSuperAdminAccess = roles.includes('Super Sys Admin') || roles.includes('Distributor Admin') ? true : false;
const baseUrl = config.apiUrl;
const pythonUrl = config.pythonUrl;
let cookie = new Cookie();
let tenantId = cookie.get("entityId");
const headers = {
    "Content-Type": "application/json",
    "X-tenantID": TenantID,
    "X-Authorization": `Bearer ${accessToken}`,
};

/** Route user-management & entity-service calls to pythonUrl; everything else to apiUrl. */
const getBaseUrl = (url = '') => {
    const path = url.replace(/^\//, '');
    if (
        path.startsWith('user-management-service') ||
        path.startsWith('entity-service')
    ) {
        return pythonUrl;
    }
    return baseUrl;
};

export const GET = (url) => {
    return axios(`${getBaseUrl(url)}/${url}`, {
        method: "GET",
        headers: headers,
    });
};

export const PUT = (url, data) => {
    return axios(`${getBaseUrl(url)}/${url}`, {
        method: "PUT",
        headers: headers,
        data,
    });
};

export const POST = (url, data) => {
    return axios(`${getBaseUrl(url)}/${url}`, {
        method: "POST",
        headers: headers,
        data,
    });
};

export const DELETE = (url,data) => {
    return axios(`${getBaseUrl(url)}/${url}`, {
        method: "DELETE",
        headers: headers,
        data,
    });
};

export const PATCH = (url, data) => {
    return axios(`${getBaseUrl(url)}/${url}`, {
        method: "PATCH",
        headers: headers,
        data,
    });
};
// General Config helper
export const getGeneralConfig = () => GET("entity-service/generalConfig");
// User General Config helper
export const getUserGeneralConfig = () => GET("user-management-service/user/generalConfig");
// Cost Center helpers
export const getCostCenterBySite = (siteId) => GET(`entity-service/costCenter/site/${siteId}`);
// Entity helpers GET request

export const getEntities = () => GET(`entity-service/entity`);
export const getEntitiesByTenant = (tenantId) => GET(`entity-service/entity/${tenantId}`);


export const getEntityById = (id) => GET(`entity-service/entity/${id}`);
export const getEntityTypes = () => GET(`entity-service/entity/entityType`);
export const getEntityLogo = (tenantId) => GET(`entity-service/entity/logo?id=${tenantId}`);